module.exports = __webpack_public_path__ + "img/20MY_PH_EU_LHD_INFORM_IP_190523.29fe8961.jpg";